// Paid plans that currently grant full feature access.
// proMonth/proMonth_yearly and professional/professional_yearly are legacy
// plans kept for existing subscribers. signal/workflow/teams (+ yearly) are
// the current plans. "starter"/"starter_yearly" are sold again on the pricing
// page as the cheapest paid tier.
export const PAID_PLANS = [
  // Starter is sold again on the pricing page: fewer comments (300/month) but the
  // same platform access as the other paid tiers.
  "starter",
  "starter_yearly",
  "proMonth",
  "proMonth_yearly",
  "professional",
  "professional_yearly",
  "signal",
  "signal_yearly",
  "workflow",
  "workflow_yearly",
  "teams",
  "teams_yearly",
];

export const isPaidPlanActive = (userData) =>
  PAID_PLANS.includes(userData?.plan) && userData?.paidStatus === true;
